module.exports = __webpack_public_path__ + "assets/img/facetop.e6a79878.png";